import React, { useEffect, useState, Fragment } from 'react';
import { paginate, Pagination, PageHeader } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import { TableCard } from '../../Common'
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { search } from '../../Common';
import { factoryItemValidationSchemaObject } from '../../Data';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { CommonEncryptParam } from '../../../../utils/CommonParams';

const screenCode = 'DEDUCTIONTEMPLATE';

export function DeductionListing(props){

    const [deduction, setDeduction] = useState([]);
    const [allDeduction, setAllDeduction] = useState([])
    const [pageSize, setPageSize] = useState(4)
    const [currentPage, setCurrentPage] = useState(1);
    const [searchStr, setSearchStr] = useState("")
    const [groups, setGroups] = useState();
    const [searchForm, setSearchForm] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0
    });
    const [factories, setFactories] = useState();
    const [collectionPoints, setCollectionPoints] = useState();
    const contentRowNames = [ "collectionPointName","collectionCategoryMenuName", "deductionTypeName","applyMethodName", "isDefaultValueEnabled", "deductionOrder", "deductionSequence", "isActive"]
    const [isTableHide, setIsTableHide] = useState(true);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
   
    const [collectionCategoryMenus, setCollectionCategoryMenus] = useState([]);


    useEffect(() => {
	trackPromise(
        getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            FactoryByGroupEntity()
            )
    }, [searchForm.groupID]);

    useEffect(() => {
        handleSearch();
    }, [searchForm.collectionPointID]);

    useEffect(() => {
        trackPromise(
            CollectionPointsByOperationEntity()
        )
    }, [searchForm.operationEntityID]);
    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDEDUCTIONTEMPLATELISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITDEDUCTIONTEMPLATE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        
        setGroupDropDownData();
    }

    async function FactoryByGroupEntity() {
        let filteredData = await services.getOperationalEntityByGroupEntityID(searchForm.groupID);
        setFactories(filteredData)
    }

    async function CollectionPointsByOperationEntity() {
        let filteredData = await services.getCollectionPointByOperationEntityId(searchForm.groupID, searchForm.operationEntityID);
        
        setCollectionPoints(filteredData)
    }

    async function getAllDeductionTemplates(groupid, factoryId, collectionPointID) {
        const data = await services.getAllByFilter(groupid, factoryId, collectionPointID);
        return data;
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function CollectionCategoryMenus(){
        const result = await services.getCollectionCategoryMenusForDropdown(searchForm.collectionPointID);
        setCollectionCategoryMenus(result);
    }


    function handleClick(deduction) {
        console.log(deduction)
        props.history.push({
            pathname: 'deduction/addEdit/'+ CommonEncryptParam(deduction.deductionTemplateID.toString()),
            data: deduction,
            edit: true
        })
    }

    function handlePageChnage(page) {
        setCurrentPage(page)
    }

    function generateDropDownMenu(data) {
       
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleChange(e) {

        const target = e.target

        const value = target.name === 'isActive' ? target.checked : target.value
        setSearchForm({

            ...searchForm,

            [e.target.name]: value

        })

    }

    async function handleSearch() {
        if (searchForm.groupID != 0 && searchForm.operationEntityID != 0 && searchForm.collectionPointID != 0){
            destroyDataTable();
            var data = await getAllDeductionTemplates(searchForm.groupID, searchForm.operationEntityID, searchForm.collectionPointID);
            setAllDeduction(data)
            createDataTable();
        }
    }

    function destroyDataTable() {
        setIsTableHide(true);
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
        setIsTableHide(false)
    }



    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Deduction Template"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Deduction Template"
                            path="deduction/addEdit" />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise( handleSearch(e))}>

                                <div className="form-group row">

                                    <div className="col-md pb-1">

                                        <InputLabel shrink id="groupID">Group *</InputLabel>

                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>

                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchForm.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={searchForm.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoints)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                                </div>

                            </form>
                            { /*<SearchFeild onSearchChange={onSearchChange} data={filterData} /> */}
                            <div className="table-responsive row-top-gap" hidden={isTableHide}>
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Collection Point </th>
                                            <th> Collection Category Menu </th>
                                            <th>Deduction Type </th>
                                            <th>Apply Method</th>
                                            <th>Default Value Enabled</th>
                                            <th>Deduction Order</th>
                                            <th>Deduction Sequence</th>
                                            <th>Status</th>
                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={allDeduction}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


